import z from "zod";
import { UserSchema } from "../user/userSchema";

export const ReactionSchema = z.object({
  created_by: UserSchema,
  type: z.string(),
});

export const CommentSchema = z.object({
  id: z.string().or(z.number()),
  created_by: UserSchema,
  created_at: z.string(),
  read_by: z.array(UserSchema.shape.user_id),
  content: z.string(),
  reactions: z.array(ReactionSchema).optional(),
});

export const ConversationSchema = z.object({
  comments: z.array(CommentSchema),
  key: z.string(),
  type: z.union([z.literal("block"), z.literal("section")]),
  involved_users: z.array(UserSchema).catch([]),
  resolved: z.union([z.boolean(), z.literal(0), z.literal(1)]).optional(),
  delete: z.boolean().optional(),
});

export const ConversationsSchema = z.array(ConversationSchema);

export type IReaction = z.infer<typeof ReactionSchema>;
export type IComment = z.infer<typeof CommentSchema>;
export type IConversation = z.infer<typeof ConversationSchema>;
